import store from '../store';

export const getNpiValidationMessage = () => {
  const state = (store?.getState()?.app?.entities?.resources ?? {})['npi.validation.text'] ?? {};
  return `${state?.data?.content ?? ''} ${state?.data?.phone ?? ''}`;
};
